import { Map } from 'immutable';
import reduceReducers from 'reduce-reducers';
import { reducer as surchargesReducer } from '../Surcharges';

const initialState = Map();

const reducer = (state = initialState) => state;

export default reduceReducers(initialState, reducer, surchargesReducer);
